import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DISCOUNT_LONG_TERM_NEW_ITEM_FOR_LONG_TERM_STAY_QUERY } from "./schema";

export const useDiscountLongTermNewItemForLongStayTermQuery = (hotelID: string, duplicateDiscountId?: string) => {
	const { data } = useCustomSuspenseQuery(DISCOUNT_LONG_TERM_NEW_ITEM_FOR_LONG_TERM_STAY_QUERY, {
		variables: { hotelID, duplicateDiscountId },
		fetchPolicy: "no-cache",
	});

	return {
		discountLongTermNewItemForLongStayTermServerModel: data,
	};
};
